export default __webpack_public_path__ + "static/media/Ies_logo_ImpactoZ.0940bf3e.png";